import type { CustomCellEditorProps } from 'ag-grid-react';
import { useGridCellEditor } from 'ag-grid-react';
import { useRef } from 'react';
import { Input } from '../Form/Input';
import type { FormControlProps } from '../Form/types';
import { agGridStaticCellClassIsRightAligned } from './agGridStaticCellClass';

export const AgGridInput = ({
  size,
  node,
  colDef,
  parseValue,
  value,
  onValueChange,
  initialValue,
  ...props
}: CustomCellEditorProps & FormControlProps<HTMLInputElement>) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useGridCellEditor({
    afterGuiAttached() {
      inputRef.current?.focus();
    },
    focusIn() {
      inputRef.current?.focus();
    },
  } as Parameters<typeof useGridCellEditor>[0]);

  const isRightAligned = agGridStaticCellClassIsRightAligned(colDef.cellClass);

  return (
    <Input
      ref={inputRef}
      onChange={e => {
        const parsedValue = parseValue(e.target.value);
        onValueChange(parsedValue);
      }}
      value={value ?? ''}
      size={size}
      style={{
        width: '100%',
        height: `${node.rowHeight}px`,
        background: props.context.current.theme?.backgroundBody,
      }}
      type={isRightAligned ? 'number' : 'text'}
    />
  );
};
